import * as React from "react";
import type { SVGProps } from "react";
const SvgTennisCourtIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14 2C7.375 2 2 7.375 2 14s5.375 12 12 12 12-5.375 12-12S20.625 2 14 2m0 1.043q.066.001.133.004A9.5 9.5 0 0 0 14 4.609C14 9.792 18.208 14 23.391 14c.532 0 1.054-.047 1.563-.133l.002.133A10.943 10.943 0 0 1 14 24.956l-.133-.003c.085-.508.133-1.03.133-1.562C14 18.208 9.792 14 4.609 14c-.532 0-1.054.047-1.562.133q-.003-.067-.004-.133A10.943 10.943 0 0 1 14 3.043m1.179.064a10.94 10.94 0 0 1 9.714 9.714 8.4 8.4 0 0 1-1.502.136 8.335 8.335 0 0 1-8.347-8.348q.002-.771.135-1.502M4.609 15.044a8.335 8.335 0 0 1 8.348 8.347c0 .514-.048 1.015-.136 1.502a10.94 10.94 0 0 1-9.714-9.714 8.4 8.4 0 0 1 1.502-.136"
    />
  </svg>
);
export default SvgTennisCourtIcon;
